import { Locale } from '@ps-smart-cp/ppfw-client';
import { enumToName, rawValueToEnum } from '../utils';

enum TotalUnit {
  specifySelection = '0',
  specifyInput = '1',
}

const nameConfig = {
  specifyInput: new Map([
    [Locale.ja, '入力指定'],
    [Locale.en, 'Specify Input'],
  ]),
  specifySelection: new Map([
    [Locale.ja, '選択指定'],
    [Locale.en, 'Specify Selection'],
  ]),
};

const toEnum = rawValueToEnum(TotalUnit, TotalUnit.specifyInput);
const toDisplay = enumToName(TotalUnit, nameConfig);
const toDisplayWithPrefix = enumToName(TotalUnit, nameConfig, { prefix: true });

export const totalUnit = {
  enum: TotalUnit,
  nameConfig,
  toEnum,
  toDisplay,
  toDisplayWithPrefix,
};
export type { TotalUnit };
